// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"0a8d0b64","421":"d064004b","496":"2fb63aee"}[chunkId] + ".chunk.js";
};